import { render } from "./LegislationCategory.vue?vue&type=template&id=77037a46"
import script from "./LegislationCategory.vue?vue&type=script&lang=js"
export * from "./LegislationCategory.vue?vue&type=script&lang=js"

import "./LegislationCategory.vue?vue&type=style&index=0&id=77037a46&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__